import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "game" }
const _hoisted_2 = ["alt", "src"]

import GameDTO from "@/models/GameDTO";
import SvgIcon from "@/components/SvgIcon.vue";
import {useStore} from "vuex";
import {api} from "@/service/APIClient";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'GameIcon',
  props: {
    game: {},
    hideFav: { type: Boolean },
    beforePlay: { type: Function }
  },
  emits: ['favoriteChanged'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const router = useRouter()

const emit = __emit

const store = useStore()
const toggleFavorite = (game: GameDTO) => {
  api.call.games.toggleFavorite(game.id, game.isFavorite ? 'unmark' : 'mark')
  emit('favoriteChanged', {...game, isFavorite: !game.isFavorite})
}

const play = async () => {
  if (!store.getters.isLoggedIn) {
    router.push({name: 'login'})
    return;
  }

  props.beforePlay && await props.beforePlay()
  router.push({name: 'gameWrapper', params: {id: props.game.id}})
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "#",
      onClick: _withModifiers(play, ["prevent"])
    }, [
      _createElementVNode("img", {
        alt: _ctx.game.name,
        src: _ctx.game.icon
      }, null, 8, _hoisted_2)
    ]),
    (_unref(store).getters.isLoggedIn && _ctx.hideFav !== true)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (toggleFavorite(_ctx.game)), ["prevent"])),
          class: _normalizeClass(["fav", {selected: _ctx.game.isFavorite}])
        }, [
          _createVNode(SvgIcon, {
            icon: "fav",
            class: "d-flex"
          })
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("a", {
      href: "#",
      onClick: _withModifiers(play, ["prevent"]),
      class: "name"
    }, _toDisplayString(_ctx.game.name), 1)
  ]))
}
}

})